const doc = [({"da":({"js":({"merfoto":({"order_deliveries":({"delivery_methods":({"shipmondo":({"index":({"zip_code":"Postnummer"})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;